import React from 'react';

export default function StatusPage() {
  const env = {
    hasSupabaseUrl: Boolean(process.env.REACT_APP_SUPABASE_URL),
    hasSupabaseAnonKey: Boolean(process.env.REACT_APP_SUPABASE_ANON_KEY),
    nodeEnv: process.env.NODE_ENV,
  };
  const isDbConfigured = env.hasSupabaseUrl && env.hasSupabaseAnonKey;
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 p-6">
      <div className="max-w-2xl mx-auto bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-6 space-y-4">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">App Status</h1>
        <ul className="text-sm text-gray-700 dark:text-gray-200 space-y-2">
          <li>NODE_ENV: <span className="font-mono">{env.nodeEnv || 'unknown'}</span></li>
          <li>Supabase URL present: <strong>{env.hasSupabaseUrl ? 'yes' : 'no'}</strong></li>
          <li>Supabase Anon Key present: <strong>{env.hasSupabaseAnonKey ? 'yes' : 'no'}</strong></li>
          <li>DB mode (by env): <strong>{isDbConfigured ? 'enabled' : 'mock/offline'}</strong></li>
          <li>Location.pathname: <span className="font-mono">{typeof window !== 'undefined' ? window.location.pathname : ''}</span></li>
        </ul>
        {!isDbConfigured && (
          <p className="text-amber-600 dark:text-amber-300 text-sm">Supabase env vars are missing; the app is running without persistence.</p>
        )}
      </div>
    </div>
  );
}
